import { render, staticRenderFns } from "./TopTips.vue?vue&type=template&id=311d884d&scoped=true"
import script from "./TopTips.vue?vue&type=script&lang=js"
export * from "./TopTips.vue?vue&type=script&lang=js"
import style0 from "./TopTips.vue?vue&type=style&index=0&id=311d884d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d884d",
  null
  
)

export default component.exports